var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXfunLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 57.976,
    height: 60,
    viewBox: "0 0 57.976 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.45,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.805,
    stopColor: "#00254f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.922,
    stopColor: "#0f315e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c3b6a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30484",
    "data-name": "Path 30484",
    d: "M17.2,74.651l.228,23.605a4.533,4.533,0,0,0,2.258,3.877L40.076,113.9a1.541,1.541,0,0,0,2.3-1.346l-.251-25.27a1.524,1.524,0,0,0-.775-1.323L19.435,73.305a1.436,1.436,0,0,0-.753-.205A1.539,1.539,0,0,0,17.2,74.651h0",
    transform: "translate(-17.2 -73.1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30485",
    "data-name": "Path 30485",
    d: "M149.467,73.228,127.275,85.909a1.561,1.561,0,0,0-.775,1.346l.251,25.293a1.514,1.514,0,0,0,1.551,1.505,1.436,1.436,0,0,0,.753-.205l20.435-11.791a4.53,4.53,0,0,0,2.258-3.923V74.528A1.5,1.5,0,0,0,150.288,73a1.543,1.543,0,0,0-.821.228",
    transform: "translate(-126.5 -73)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "xfun_logo_colour",
    transform: "translate(-0.1 0.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "x",
    transform: "translate(0.1 -0.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30482",
    "data-name": "Path 30482",
    d: "M.123,16V.906C.123.085,1.332-.325,2.061.222L28.313,20.475a1.335,1.335,0,0,0,1.574,0L56.137.222c.73-.57,1.939-.137,1.939.684V16a.9.9,0,0,1-.365.684l-16.33,12.59a.81.81,0,0,0,0,1.346L57.688,43.237a.866.866,0,0,1,.365.684V59c0,.821-1.209,1.232-1.939.684L29.863,39.359a1.335,1.335,0,0,0-1.574,0L2.039,59.7c-.73.57-1.939.137-1.939-.684V43.944a.9.9,0,0,1,.365-.684L16.772,30.647a.81.81,0,0,0,0-1.346L.465,16.689A.874.874,0,0,1,.123,16Z",
    transform: "translate(-0.1 0.037)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dice",
    transform: "translate(4 1.73)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30483",
    "data-name": "Path 30483",
    d: "M65.737,20.48l-.205-.114-.205-.137L44.892,8.438a4,4,0,0,0-.639-.3,3.674,3.674,0,0,0-3.535.046L27.763,15.645l-8.051,4.607a1.741,1.741,0,0,0-.251.182l-.137.068A3.641,3.641,0,0,0,17.5,23.651v24.2a4.312,4.312,0,0,0,2.189,3.763L40.741,63.723a3.672,3.672,0,0,0,3.626,0L65.783,51.407a3.641,3.641,0,0,0,1.825-3.147V23.628A3.815,3.815,0,0,0,65.737,20.48Z",
    transform: "translate(-17.432 -7.711)",
    fill: "#ec1966"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24918",
    "data-name": "Group 24918",
    transform: "translate(0 14.913)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-3",
    d: "M17.2,74.651l.228,23.605a4.533,4.533,0,0,0,2.258,3.877L40.076,113.9a1.541,1.541,0,0,0,2.3-1.346l-.251-25.27a1.524,1.524,0,0,0-.775-1.323L19.435,73.305a1.436,1.436,0,0,0-.753-.205A1.539,1.539,0,0,0,17.2,74.651h0",
    transform: "translate(-17.2 -73.1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24917",
    "data-name": "Group 24917"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24916",
    "data-name": "Group 24916"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24915",
    "data-name": "Group 24915",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11581",
    "data-name": "Rectangle 11581",
    width: 42.604,
    height: 48.42,
    transform: "matrix(0.864, -0.504, 0.504, 0.864, -18.009, 10.528)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_24922",
    "data-name": "Group 24922",
    transform: "translate(24.928 14.891)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "SVGID-4",
    d: "M149.467,73.228,127.275,85.909a1.561,1.561,0,0,0-.775,1.346l.251,25.293a1.514,1.514,0,0,0,1.551,1.505,1.436,1.436,0,0,0,.753-.205l20.435-11.791a4.53,4.53,0,0,0,2.258-3.923V74.528A1.5,1.5,0,0,0,150.288,73a1.543,1.543,0,0,0-.821.228",
    transform: "translate(-126.5 -73)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24921",
    "data-name": "Group 24921",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24920",
    "data-name": "Group 24920"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24919",
    "data-name": "Group 24919",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11582",
    "data-name": "Rectangle 11582",
    width: 38.704,
    height: 47.781,
    transform: "translate(-14.169 5.614) rotate(-21.611)"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_30486",
    "data-name": "Path 30486",
    d: "M98.826,52.515a6.654,6.654,0,0,1-2.483-.476l-.969-.528L89.16,47.971a.912.912,0,1,1,.9-1.585l6.2,3.535.856.473a4.9,4.9,0,0,0,1.7.3c1.788,0,3.033-.889,3.033-1.688a1.321,1.321,0,0,0-.62-1,.813.813,0,0,1-.106-.05l-.319-.182L95.154,44.5a.912.912,0,1,1,.911-1.581l5.874,3.386a.823.823,0,0,1,.119.055,3.185,3.185,0,0,1,1.624,2.588C103.684,50.973,101.55,52.515,98.826,52.515Z",
    transform: "translate(-72.392 -34.797)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30487",
    "data-name": "Path 30487",
    d: "M171.081,145.584a.912.912,0,0,1-.912-.906l-.068-10.126a.912.912,0,0,1,1.6-.606l4.3,4.926-.034-7.356a.912.912,0,1,1,1.825-.008l.046,9.807a.912.912,0,0,1-1.6.6L171.941,137l.052,7.667a.912.912,0,0,1-.906.918Z",
    transform: "translate(-135.228 -102.572)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_23",
    "data-name": "Union 23",
    d: "M2553.048,22137.307l-.05-13.162a.914.914,0,0,1,1.361-.795l8.9,5.018a.911.911,0,1,1-.895,1.588l-7.528-4.244.017,4.895,6.778,3.734a.911.911,0,0,1-.439,1.711.892.892,0,0,1-.439-.117l-5.894-3.24.016,4.607a.911.911,0,1,1-1.823.006Z",
    transform: "translate(-2545.77 -22095.387)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXfunLogo);
export default __webpack_public_path__ + "static/media/xfun-logo.415f46c188f5209189192a6190bc4854.svg";
export { ForwardRef as ReactComponent };